import {
  getPatientLabelFirstLine,
  Order,
  getProductsOrderedCountLabel,
} from "@jasper/shared";
import { Badge, Group, Stack, Text, UnstyledButton } from "@mantine/core";
import { useHover } from "@mantine/hooks";
import { useNavigate } from "react-router-dom";

import { GetManyOrdersOfUserQuery } from "/@/generated/graphql";
import { getOrderStatusPresentation } from "/@/pages/dashboard/orderStatus";

interface Props {
  order: GetManyOrdersOfUserQuery["getManyOrdersOfUser"][number];
  onSelect: () => void;
}

export const OrderSearchResult = ({ order, onSelect }: Props) => {
  const navigate = useNavigate();
  const { hovered, ref } = useHover<HTMLButtonElement>();
  const status = getOrderStatusPresentation(order.status);
  const productsLabel = getProductsOrderedCountLabel(order as unknown as Order);

  return (
    <UnstyledButton
      ref={ref}
      onClick={() => {
        navigate(`/order/${order.id}`);
        onSelect();
      }}
      aria-label={`Ouvrir la commande ${order.orderReference ?? ""} de ${getPatientLabelFirstLine(order)}`}
      w="100%"
      px="s4"
      py="s3"
      bg={hovered ? "ink.0" : undefined}
    >
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Stack gap={2} miw={0}>
          <Text variant="strong" truncate="end">
            {getPatientLabelFirstLine(order)}
          </Text>
          {productsLabel && (
            <Text variant="caption" truncate="end">
              {productsLabel}
            </Text>
          )}
          {order.orderReference && (
            <Text variant="caption">{order.orderReference}</Text>
          )}
        </Stack>
        <Badge color={status.color}>{status.label}</Badge>
      </Group>
    </UnstyledButton>
  );
};
